module.exports = __webpack_public_path__ + "img/products-banner.f7b44ef6.png";